export default "__VITE_ASSET__BuUnVwSx__"